import axios from "axios";

const portalUrl = "";
const fetchWithAuth = async (url) => {
  if (!window.Liferay) {
    throw new Error("Liferay session not available");
  }

  const response = await fetch(url, {
    credentials: "include",
    headers: {
      "X-CSRF-Token": window.Liferay?.authToken,
      "Content-Type": "application/json",
      Accept: "application/json"
    },
  });
  if (!response.ok) {
    const text = await response.text();
    console.error("API ERROR:", response.status, text);
    throw new Error(`HTTP ${response.status}`);
  }

  return response.json();
};


export const getATMStates = async () => {
  const data = await fetchWithAuth(
    `${portalUrl}/o/c/branchlocatorstates?fields=stateName&pageSize=36&page=1`
  );

  const map = new Map();

  data.items.forEach(i => {
    if (!i.stateName) return;
    const key = i.stateName.trim().toUpperCase();
    if (!map.has(key)) {
      map.set(key, i.stateName.trim());
    }
  });

  return [...map.values()].sort((a, b) => a.localeCompare(b));
};

export const getATMUnitStates = async () => {
  const data = await fetchWithAuth(
    `${portalUrl}/o/c/atmunitstates?fields=stateName&pageSize=36&page=1`
  );

  const map = new Map();

  data.items.forEach(i => {
    if (!i.stateName) return;
    const key = i.stateName.trim().toUpperCase();
    if (!map.has(key)) {
      map.set(key, i.stateName.trim());
    }
  });

  return [...map.values()].sort((a, b) => a.localeCompare(b));
};

export const getATMDistricts = async (state) => {
  const filter = encodeURIComponent(`stateName eq '${state}'`);

  const data = await fetchWithAuth(
    `${portalUrl}/o/c/districts/?fields=district&pageSize=75&filter=${filter}`
  );

  const map = new Map();

  data.items.forEach(i => {
    if (!i.district) return;
    const key = i.district.trim().toUpperCase();
    if (!map.has(key)) map.set(key, i.district.trim());
  });

  return [...map.values()].sort();
};
export const getATMUnitDistricts = async (state) => {
  const filter = encodeURIComponent(`stateName eq '${state}'`);

  const data = await fetchWithAuth(
    `${portalUrl}/o/c/adminunitdistricts/?fields=district&filter=${filter}`
  );

  const map = new Map();

  data.items.forEach(i => {
    if (!i.district) return;
    const key = i.district.trim().toUpperCase();
    if (!map.has(key)) map.set(key, i.district.trim());
  });

  return [...map.values()].sort();
};
export const searchATMs = async (
  state,
  district,
  branch,
  searchText,
  page = 1,
  pageSize = 5
) => {

  let url = `${portalUrl}/o/c/branchlocators/?pageSize=${pageSize}&page=${page}`;

  if (searchText && searchText.trim()) {
    url += `&search=${encodeURIComponent(searchText.trim())}`;
  } else {
    const filters = [];

    if (state) filters.push(`state eq '${state}'`);
    if (district) filters.push(`district eq '${district}'`);
    if (branch && branch !== "All")
      filters.push(`branchName eq '${branch}'`);

    if (filters.length) {
      url += `&filter=${encodeURIComponent(filters.join(" and "))}`;
    }
  }

  const data = await fetchWithAuth(url);

  return {
    items: data.items || [],
    totalCount: data.totalCount || 0
  };
};

export const searchAdminUnits = async (
  state,
  district,
  branch,
  searchText,
  page = 1,
  pageSize = 5
) => {

  let url = `${portalUrl}/o/c/adminunits/?pageSize=${pageSize}&page=${page}`;

  if (searchText && searchText.trim()) {
    url += `&search=${encodeURIComponent(searchText.trim())}`;
  } else {
    const filters = [];

    if (state) filters.push(`state eq '${state}'`);
    if (district) filters.push(`district eq '${district}'`);
    if (branch && branch !== "All")
      filters.push(`branchName eq '${branch}'`);

    if (filters.length) {
      url += `&filter=${encodeURIComponent(filters.join(" and "))}`;
    }
  }

  const data = await fetchWithAuth(url);

  return {
    items: data.items || [],
    totalCount: data.totalCount || 0
  };
};



export const getAdminDistricts = async (state) => {
  const filter = encodeURIComponent(`state eq '${state}'`);

  const data = await fetchWithAuth(
    `${portalUrl}/o/c/adminunits/?pageSize=0&filter=${filter}`
  );

  const map = new Map();
  data.items.forEach(i => {
    if (!i.district) return;
    const key = i.district.trim().toUpperCase();
    if (!map.has(key)) {
      map.set(key, i.district.trim());
    }
  });

  return [...map.values()].sort();
};
export async function getCount(locatorType) {
  const url =
    locatorType === "ADMIN"
      ? `${portalUrl}/o/c/adminunits`
      : `${portalUrl}/o/c/branchlocators`;

  const response = await fetchWithAuth(url);
  console.log("data count-------", response.totalCount);

  return response.totalCount; 
}

